export const environment = {
  production: false,
  name: 'local',
  apiBaseUrl: 'https://sonibizfuncprod-hmekauawhtf5cyfy.southindia-01.azurewebsites.net/api',
};
